export default function MySQL_TIME_TO_SEC() {
  return (
    <div>
      <h2>MySQL_TIME_TO_SEC</h2>    </div>
  );
}